/**
 * Авторизация
 * @return Promise
 */
const userLogin = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/auth/login",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Выход
 * @return Promise
 */
const userLogout = function() {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/auth/logout"
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Данные авторизованного пользователя
 * @return Promise
 */
const userLoad = function() {
  return new Promise((resolve, reject) =>
    this.request({
      method: "GET",
      url: "/user/getInfo"
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Обратная связь
 * @return Promise
 */
const sendMessage = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/support/sendMessage",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export { userLoad, userLogout, userLogin, sendMessage };
